import React, { useContext, useEffect, useState } from 'react';
import {
  DialogContent,
  LinearProgress,
  Button,
  Dialog,
  DialogTitle,
  IconButton,
  FormControl,
  Alert,
} from '@mui/material';
import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import { isDesktop, isMobile, isTablet } from 'react-device-detect';
import DownloadIcon from '@mui/icons-material/Download';
import { ClearIcon } from '@mui/x-date-pickers';
import { format } from 'date-fns';
import { AuthContext } from '../../../../contexts/user-context/user-context';
import { API_ENDPOINT } from '../../../../configurations/global.config';
import axios from 'axios';
import { IDeliveryBatch } from '../../../../interfaces/delivery-company/tasks';
import { TaskPrinter } from '../../../common/task-barcode-printer/task-barcode-printer';
import CustomDialog from '../../../common/custom-dialog/custom-dialog';
import { OrderType } from '../../../../interfaces/delivery-company/orders';
import ReturnStatements from '../../../common/return-statements/return-statements';
import { OrgSettingsContext } from '../../../../contexts/org-settings-context';
import { PrintWaybillsMultiSizes } from '../../../common/bulk-action/print-waybills';

interface TaskWaybillsDialogProps {
  task: IDeliveryBatch;
  mode: 'batch' | 'orders' | 'returns';
  onClose: () => void;
}

function TaskWaybillsDialog({ task, onClose, mode }: TaskWaybillsDialogProps) {
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { user, config } = useContext(AuthContext);
  const [taskData, setTaskData] = useState<IDeliveryBatch>();

  useEffect(() => {
    if (task != null) {
      // fetch task orders
      setIsLoading(true);
      const getTaskData = async () => {
        let taskDataFromBackend: IDeliveryBatch;
        const endpoint = `${API_ENDPOINT}/api/v1/delivery-batch/${task.id}/`;
        try {
          console.log(endpoint);
          const response = await axios.get<IDeliveryBatch>(endpoint, config);
          console.log(response);
          setTaskData(response.data);
        } catch (error) {
          console.log(error);
        }
        setIsLoading(false);
      };
      getTaskData();
    }
  }, [task?.id]);

  let title = 'Batch QR Code';
  if (mode === 'orders') title = 'Packages Waybills';
  if (mode === 'returns') title = 'Return Statements';

  const { color } = useContext(OrgSettingsContext);

  return (
    <CustomDialog open={isOpen} onClose={onClose} maxWidth="md">
      <div
        style={{
          textAlign: 'right',
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <DialogTitle>{title}</DialogTitle>
        <IconButton
          onClick={() => {
            onClose && onClose();
            setIsOpen(false);
          }}
        >
          <ClearIcon color="primary" fontSize="large" />
        </IconButton>
      </div>

      <DialogContent
        style={
          (isDesktop || isTablet)
            ? { width: 'auto', height: 'auto', textAlign: 'center' }
            : {}
        }
      >
        {isLoading ? (
          <>
            Getting task details ... <br />
            <LinearProgress />
          </>
        ) : (
          <>
            {taskData ? 
                  mode === 'orders' ? (
                    <PrintWaybillsMultiSizes
                      onClose={onClose}
                      orders={taskData.orders}
                    />
                  )  : (
                      <PDFDownloadLink
                        document={
                          mode === 'returns' ? (
                            <ReturnStatements
                              orders={taskData.orders}
                              orgId={user?.organisation?.org_id ?? 'ERROR'}
                              color={color}
                            />
                          ) : 
                          <TaskPrinter
                            task={taskData}
                            orgId={user?.organisation?.org_id ?? 'ERROR'}
                          />                  
                    }
                    fileName={`${mode}.${taskData.id}.${taskData.creation_date ?? ''}.pdf`}
                  >  
                    {({ loading } : {loading: boolean}) => {
                      return loading ? (
                        <Button
                          size={(isMobile && !isTablet) ? 'small' : 'medium'}
                          color="primary"
                          disabled
                        >
                          Loading...
                        </Button>
                      ) : (
                        <Button
                          size={(isMobile && !isTablet) ? 'small' : 'medium'}
                          color="primary"
                        >
                          <DownloadIcon fontSize="large" />
                        </Button>
                      );
                    }}
                  </PDFDownloadLink>
                )   
             : (
              <Alert severity="error">
                Failed to get task data. Please contact us.
              </Alert>
            )}
          </>
        )}
      </DialogContent>
    </CustomDialog>
  );
}

export default TaskWaybillsDialog;
